import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import { Button, Card, CardContent, Grid, MenuItem, TextField, Typography } from '@material-ui/core';
import { AddCircle } from '@material-ui/icons';

const styles = theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(2),
        overflowY: 'auto',
    },
    form: {
        width: 'min(92vw, 560px)',
        maxHeight: '90vh',
        overflowY: 'auto',
        backgroundColor: '#494A49',
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        color: theme.palette.secondary.main,
        textAlign: 'center',
        padding: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            width: '94vw',
            maxHeight: '92vh',
        },
    },
    formContent: {
        padding: theme.spacing(2, 2, 3),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1.5, 1.25, 2.5),
        },
    },
    title: {
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(1),
        fontWeight: 700,
        [theme.breakpoints.down('sm')]: {
            fontSize: '2rem',
            lineHeight: 1.2,
        },
    },
    contestText: {
        width: '100%',
        '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
            borderColor: 'white'
        }
    },
    contestDateTime: {
        width: '100%',
        '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
            borderColor: 'white'
        }
    },
    timeOptions: {
        '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
            borderColor: 'white'
        }
    },
    contestNumber: {
        width: '100%',
        '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
            borderColor: 'white'
        }
    },
    input: {
        color: 'white'
    },
    cssOutlinedInput: {
        '&$cssFocused $notchedOutline': {
            borderColor: 'white',
        },
    },
    cssFocused: {},
    notchedOutline: { borderColor: 'white' },
    submitButton: {
        marginTop: theme.spacing(1.5),
    },
});

class NewContestForm extends Component {

    state = {
        newContest: {
            contestName: '',
            startDate: '',
            startTime: '',
            numberOfHours: 0,
            numberOfQuestions: 0,
        },
        open: false,
    }

    handleInputChangeFor = propertyName => (event) => {
        this.setState({
            newContest: {
                ...this.state.newContest,
                [propertyName]: event.target.value
            }
        });
    }

    addContest = (event) => {
        event.preventDefault();
        this.props.dispatch({
            type: 'ADD_CONTEST',
            payload: this.state.newContest
        })

        this.handleClose();
        this.setState({
            newContest: {
                contestName: '',
                startDate: '',
                startTime: '',
                numberOfHours: 0,
                numberOfQuestions: 0,
            }
        })
    }

    handleOpen = () => {
        this.setState({ open: true })
    };

    handleClose = () => {
        this.setState({ open: false })
    };

    render() {

        const { classes } = this.props

        let hourSelection = []

        for (let i = 0; i < 24; i++) {
            let hourFormat = {
                displayValue: 0,
                sqlValue: 0
            }
            hourFormat.sqlValue = i;
            if (i == 0) {
                hourFormat.displayValue = '12 am'
                hourSelection.push(hourFormat);
            } else if (i < 12) {
                hourFormat.displayValue = i + ' am'
                hourSelection.push(hourFormat);
            } else if (i == 12) {
                hourFormat.displayValue = '12 pm'
                hourSelection.push(hourFormat)
            } else if (i <= 23) {
                let j = i;
                hourFormat.displayValue = j - 12 + ' pm'
                hourSelection.push(hourFormat);
            }
        }

        return (
            <div>
                <Button variant="contained" style={{ backgroundColor: this.props.user.color }} onClick={this.handleOpen}>
                    New Contest
                </Button>
                <Modal
                    aria-labelledby="new-contest-modal-title"
                    aria-describedby="new-contest-modal-description"
                    className={classes.modal}
                    open={this.state.open}
                    onClose={this.handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{ timeout: 500 }}
                >
                    <Card className={classes.form}>
                        <CardContent className={classes.formContent}>
                            <Typography id="new-contest-modal-title" variant="h3" className={classes.title} style={{ color: this.props.user.color }}>
                                Enter Contest Details
                            </Typography>
                            <form onSubmit={this.addContest}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            id="new-contest-name"
                                            label="name your contest"
                                            className={classes.contestText}
                                            value={this.state.newContest.contestName}
                                            onChange={this.handleInputChangeFor('contestName')}
                                            margin="normal"
                                            variant="outlined"
                                            InputProps={{
                                                className: classes.input,
                                                classes: {
                                                    root: classes.cssOutlinedInput,
                                                    focused: classes.cssFocused,
                                                    notchedOutline: classes.notchedOutline,
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.input,
                                                shrink: true
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            id="new-contest-start-date"
                                            type="date"
                                            label="contest start date"
                                            className={classes.contestDateTime}
                                            value={this.state.newContest.startDate}
                                            onChange={this.handleInputChangeFor('startDate')}
                                            margin="normal"
                                            variant="outlined"
                                            InputProps={{
                                                className: classes.input,
                                                classes: {
                                                    root: classes.cssOutlinedInput,
                                                    focused: classes.cssFocused,
                                                    notchedOutline: classes.notchedOutline,
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.input,
                                                shrink: true
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            id="new-contest-start-time"
                                            select
                                            label="contest start time"
                                            className={classes.contestDateTime}
                                            value={this.state.newContest.startTime}
                                            onChange={this.handleInputChangeFor('startTime')}
                                            SelectProps={{ MenuProps: { className: classes.status } }}
                                            margin="normal"
                                            variant="outlined"
                                            InputProps={{
                                                className: classes.input,
                                                classes: {
                                                    root: classes.cssOutlinedInput,
                                                    focused: classes.cssFocused,
                                                    notchedOutline: classes.notchedOutline,
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.input,
                                                shrink: true
                                            }}
                                        >
                                            {hourSelection.map((hour) => (
                                                <MenuItem key={hour.sqlValue} value={hour.sqlValue} className={classes.timeOptions}>
                                                    {hour.displayValue}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            id="new-contest-hours"
                                            type="number"
                                            label="number of hours"
                                            className={classes.contestNumber}
                                            value={this.state.newContest.numberOfHours}
                                            onChange={this.handleInputChangeFor('numberOfHours')}
                                            margin="normal"
                                            variant="outlined"
                                            InputProps={{
                                                className: classes.input,
                                                classes: {
                                                    root: classes.cssOutlinedInput,
                                                    focused: classes.cssFocused,
                                                    notchedOutline: classes.notchedOutline,
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.input,
                                                shrink: true
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            id="new-contest-questions"
                                            type="number"
                                            label="questions per hour"
                                            className={classes.contestNumber}
                                            value={this.state.newContest.numberOfQuestions}
                                            onChange={this.handleInputChangeFor('numberOfQuestions')}
                                            margin="normal"
                                            variant="outlined"
                                            InputProps={{
                                                className: classes.input,
                                                classes: {
                                                    root: classes.cssOutlinedInput,
                                                    focused: classes.cssFocused,
                                                    notchedOutline: classes.notchedOutline,
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.input,
                                                shrink: true
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            name="submit"
                                            className={classes.submitButton}
                                            style={{ backgroundColor: this.props.user.color }}
                                        >
                                            <AddCircle style={{ marginRight: 3 }} />Add Contest
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </Modal>
            </div>
        )

    }

}

const mapStateToProps = state => ({
    user: state.user,
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(NewContestForm)));
